"use client"
import {
  Input
} from "./chunk-YYT6SG4M.mjs";

// src/components/textarea.ts
import { mergeStyle, pickStyle } from "@yamada-ui/core";
var Textarea = mergeStyle(
  pickStyle(Input, "field"),
  {
    baseStyle: {
      lineHeight: "short",
      py: "2",
      verticalAlign: "top"
    },
    sizes: {
      xs: {
        minH: "20",
        py: "2"
      },
      sm: {
        minH: "20",
        py: "2"
      },
      md: {
        minH: "20",
        py: "2"
      },
      lg: {
        minH: "20",
        py: "3"
      }
    },
    variants: {
      unstyled: {
        h: "auto",
        px: "0",
        py: "0"
      }
    }
  }
)();

export {
  Textarea
};
//# sourceMappingURL=chunk-SQHN7TTU.mjs.map